import React, { useState } from 'react';
// import _debounce from 'lodash/debounce';
// import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';

import '../../../App.css';

// import { supportRequestSchema } from '../../../utils/schemas/auth';

import ComplainTable from './components/ComplainTable';
import ComplainTools from './components/ComplainTools';

const initialState = {
  isEditModalData: {},
  modalHeader: { title: '', isEdit: false },
  isEditModal: { status: false, id: '' },
  isView: { status: false },
  isDeleteModal: { status: false, id: '' },
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  search: '',
  leaveCount: 0,
  sortField: 'createdAt',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 50,
  reason: '',
  reasonError: '',
  responseReason: '',
  responseReasonError: ''
};

const ComplainList = () => {
  const [state, setState] = useState(initialState);

  /* const defaultValue = {
    userId: '',
    dateOfRequest: '',
    requestReason: ''
  }; */

  /* const {
    reset,
    watch,
     register,
     setValue,
     handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(supportRequestSchema),
    values: state.isEditModalData?._id ? state.isEditModalData : defaultValue
  }); */

  // const valuesData = watch();

  return (
    <div className="container-xxl">
      <ComplainTools state={state} setState={setState} initialState={initialState} />
      <ComplainTable state={state} setState={setState} initialState={initialState} />
    </div>
  );
};

export default ComplainList;
